/**
 * Premium
 * No Of Accepted Bid = COMPLETED + IN_TRANSIT
 */
var BID_STATUS;
(function (BID_STATUS) {
    BID_STATUS[BID_STATUS["WAITING"] = 0] = "WAITING";
    BID_STATUS[BID_STATUS["NEGOTIATED"] = 1] = "NEGOTIATED";
    BID_STATUS[BID_STATUS["ACCEPTED"] = 2] = "ACCEPTED";
    BID_STATUS[BID_STATUS["COMPLETED"] = 3] = "COMPLETED";
    BID_STATUS[BID_STATUS["IN_TRANSIT"] = 4] = "IN_TRANSIT";
    BID_STATUS[BID_STATUS["REJECTED"] = 5] = "REJECTED";
    BID_STATUS[BID_STATUS["EXPIRED"] = 6] = "EXPIRED";
    BID_STATUS[BID_STATUS["CANCELLED"] = 7] = "CANCELLED";
    BID_STATUS[BID_STATUS["STAND_BY"] = 8] = "STAND_BY";
    BID_STATUS[BID_STATUS["PARTIALLY_ACCEPTED"] = 9] = "PARTIALLY_ACCEPTED";
    BID_STATUS[BID_STATUS["UNVERIFIED"] = 999] = "UNVERIFIED";
})(BID_STATUS || (BID_STATUS = {}));
var BID_STATUS_TEXT;
(function (BID_STATUS_TEXT) {
    BID_STATUS_TEXT["WAITING"] = "Waiting";
    BID_STATUS_TEXT["REJECTED"] = "Rejected";
    BID_STATUS_TEXT["COMPLETED"] = "Completed";
    BID_STATUS_TEXT["IN_TRANSIT"] = "In Transit";
    BID_STATUS_TEXT["NEGOTIATED"] = "Negotiated";
    BID_STATUS_TEXT["EXPIRED"] = "Expired";
    BID_STATUS_TEXT["CANCELLED"] = "Cancelled";
    BID_STATUS_TEXT["UNVERIFIED"] = "Unverified";
    BID_STATUS_TEXT["ACCEPTED"] = "Accepted";
})(BID_STATUS_TEXT || (BID_STATUS_TEXT = {}));
const AllBidStatusForCsDashboard = [
    BID_STATUS.WAITING,
    BID_STATUS.NEGOTIATED,
    BID_STATUS.IN_TRANSIT,
    BID_STATUS.STAND_BY,
    BID_STATUS.PARTIALLY_ACCEPTED,
    BID_STATUS.EXPIRED,
    BID_STATUS.COMPLETED,
    BID_STATUS.CANCELLED
];
const PostAcceptanceBidStatusList = [BID_STATUS.IN_TRANSIT, BID_STATUS.CANCELLED, BID_STATUS.COMPLETED];

export { AllBidStatusForCsDashboard, BID_STATUS, BID_STATUS_TEXT, PostAcceptanceBidStatusList };
//# sourceMappingURL=bidStatus.js.map
